import { render, staticRenderFns } from "./InvoicesLoading.vue?vue&type=template&id=688c2c74&"
import script from "./InvoicesLoading.vue?vue&type=script&lang=js&"
export * from "./InvoicesLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports